export default __webpack_public_path__ + "static/media/guyane.7e036fe2.svg";